// @fomrat
import { isNil, isEmpty, anyPass, compose, complement } from 'ramda';

export const isExist = compose(complement, anyPass)([isNil, isEmpty]);



// WEBPACK FOOTER //
// ./src/utils/ramdaUtils.js